export default () => `
<!------------- main content--------------->

    <div class="main-content">
        <div class="container1">
            <!-- header -->
            <div class="row1F">
                <div class="col-2">
                    <img src="https://github.com/asmita85/Capstone/blob/master/images/Front-Page/parker-burchfield-tvG4WvjgsEY-unsplash.jpg?raw=true" alt="my image" class="main-picture">
                </div>
                <div class="col-2">
                    <h1 class="main-title">Shop Here And Get A New Style</h1>
                    <p class= "main-message">You can easily do that in
                    the comfort of your home.
                    <p>buying is now <b>Easier</b>
                    than before!!!!
                    This is the right place
                    Our Objective is to provide you
                    with a <b>Zen</b> experience</p>
                    <a href="/${"AllProduct"}" data-navigo class="btn1 btn-shop">SHOP NOW →</a>
                </div>
            </div>
        </div>
    </div>
    <!------------- adding button--------------->
    <div class="sale1">
        <div class="small-container1">
            <div class="row1">
                <div class="col-3">
                    <a href="/${"Men"}" data-navigo>
                        <p>Men</p>
                    </a>
                </div>
                <div class="col-3">
                    <a href="/${"Women"}" data-navigo>
                        <p>Women</p>
                    </a>
                </div>
                <div class="col-3">
                    <a href="/${"Kids"}" data-navigo>
                        <p>Kids</p>
                    </a>
                </div>
            </div>
        </div>
    </div>
    <!------------- Categories--------------->

    <div class="categories1 media-hide">
        <div class="small-container1">
            <div class="row1">
                <div class="col-3">
                    <img src="https://github.com/asmita85/Capstone/blob/master/images/Men-Product/Mproduct-1.jpg?raw=true">
                </div>
                <div class="col-3">
                    <img src="https://github.com/asmita85/Capstone/blob/master/images/Women-Product/Wproduct-3.jpg?raw=true">
                </div>
                <div class="col-3">
                    <img src="https://github.com/asmita85/Capstone/blob/master/images/Kid-Product/Kproduct-14.jpg?raw=true">
                </div>
            </div>
        </div>
    </div>
    <!------------- New Arrival--------------->

    <div class="small-container1 media-hide">
        <h2 class="title1">New Arrivals</h2>
        <div class="row1">
            <div class="col-4">
                <img src="https://github.com/asmita85/Capstone/blob/master/images/Women-Product/Wproduct-1.jpg?raw=true">
                <h4>white dress</h4>
                <p>$60.00</p>
            </div>
            <div class="col-4">
                <img src="https://github.com/asmita85/Capstone/blob/master/images/Women-Product/Wproduct-2.jpg?raw=true">
                <h4>Red TOp</h4>
                <p>$50.00</p>
            </div>
            <div class="col-4">
                <img src="https://github.com/asmita85/Capstone/blob/master/images/Men-Product/Mproduct-1.jpg?raw=true">
                <h4>Jacket</h4>
                <p>$100.00</p>
            </div>
            <div class="col-4">
                <img src="https://github.com/asmita85/Capstone/blob/master/images/Men-Product/Mproduct-2.jpg?raw=true">
                <h4>Leather Jacket</h4>
                <p>$50.00</p>
            </div>
        </div>
    </div>
    <!------------- recently clicked--------------->
    <div class="sale1 ">
        <div class="small-container1">
            <h2 class="title1">Recently Viewed</h2>
            <div class="row1">
                <div class="col-3">
                    <img src="https://github.com/asmita85/Capstone/blob/master/images/Men-Product/Mproduct-3.jpg?raw=trueg">
                </div>
                <div class="col-3">
                    <img src="https://github.com/asmita85/Capstone/blob/master/images/Men-Product/Mproduct-2.jpg?raw=true">
                </div>
                <div class="col-3">
                    <img src="https://github.com/asmita85/Capstone/blob/master/images/Women-Product/Wproduct-3.jpg?raw=true">
                </div>
            </div>
        </div>
    </div>
    <!----------sale with call to action button----------->

    <div class="small-container1 ">
        <h2 class="title1">Daily deal</h2>
        <div class="row1">
            <div class="col-2">
                <img src="https://github.com/asmita85/Capstone/blob/master/images/Front-Page/image5.png?raw=true" class="img-offer1" alt="my image">
            </div>
            <div class="col-2">
                <h1>exclusive daily deal <br> Smart Watch for kids</h1>
                <p>A smartwatch is a wearable computer in the form of a watch; <br> modern smartwatches provide a local
                    touchscreen interface for daily use, while an associated.</p>
                <a href="" class="btn1">Buy Now →</a>
            </div>
        </div>
    </div>

    <!------------- offer--------------->
    <div class="sale1">
        <div class="small-container1">
            <div class="row1">
                <div class="col-3">
                    <p>exclusive deal</p>
                    <a href="" class="btn1">check it now →</a>
                </div>
                <div class="col-3">
                    <p> sale</p>
                    <a href="" class="btn1">check it now →</a>
                </div>
                <div class="col-3">
                    <p>Clearance</p>
                    <a href="" class="btn1">check it now →</a>
                </div>
            </div>
        </div>
    </div>
    <!------------- best seller--------------->

    <div class="small-container1 media-hide">
        <h2 class="title1">Best Seller</h2>
        <div class="row1">
            <div class="col-4">
                <img src="https://github.com/asmita85/Capstone/blob/master/images/Women-Product/Wproduct-3.jpg?raw=true">
                <h4>Short</h4>
                <p>$50.00</p>
            </div>
            <div class="col-4">
                <img src="https://github.com/asmita85/Capstone/blob/master/images/Women-Product/Wproduct-4.jpg?raw=true">
                <h4>White Top</h4>
                <p>$60.00</p>
            </div>
            <div class="col-4">
                <img src="https://github.com/asmita85/Capstone/blob/master/images/Women-Product/Wproduct-5.jpg?raw=true">
                <h4>Eyeglasses</h4>
                <p>$70.00</p>
            </div>
            <div class="col-4">
                <img src="https://github.com/asmita85/Capstone/blob/master/images/Women-Product/Wproduct-9.jpg?raw=true">
                <h4>White Top</h4>
                <p>$40.00</p>
            </div>
        </div>
        <div class="row1">
            <div class="col-4">
                <img src="https://github.com/asmita85/Capstone/blob/master/images/Women-Product/Wproduct-7.jpg?raw=true">
                <h4>Eyeglasses For Ananas</h4>
                <p>$30.00</p>
            </div>
            <div class="col-4">
                <img src="https://github.com/asmita85/Capstone/blob/master/images/Men-Product/Mproduct-3.jpg?raw=true">
                <h4>Eyeglasses</h4>
                <p>$50.00</p>
            </div>
            <div class="col-4">
                <img src="https://github.com/asmita85/Capstone/blob/master/images/Men-Product/Mproduct-4.jpg?raw=true">
                <h4>Pant</h4>
                <p>$80.00</p>
            </div>
            <div class="col-4">
                <img src="https://github.com/asmita85/Capstone/blob/master/images/Men-Product/Mproduct-12.jpg?raw=true">
                <h4>BLack Jean</h4>
                <p>$70.00</p>
            </div>
        </div>
    </div>
    `;
